'use client';

import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { DisabledOverlay } from "../MegaSelector/DisabledOverlay.mjs";
import { ENCORE_ADS_BUSINESS_DATA_IDS } from "../../dataEncoreIds.mjs";
import { LoadingIndicator } from "../../../core/components/LoadingIndicator/index.mjs";
import { cssColorValue, semanticColors } from "../../../core/styles/index.mjs";
import { ecx } from "../../../core/utils.mjs";
function getBorderColor(props) {
  if (props.error) return cssColorValue(semanticColors.essentialNegative);
  if (props.warning) return cssColorValue(semanticColors.essentialWarning);
  return cssColorValue(semanticColors.decorativeSubdued);
}
export var AdsBox = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  // Make use of disabled styles as well if using disabled overlay
  if (props.disabledOverlay) {
    props.disabled = true;
    props['aria-disabled'] = true;
  }
  if (props.disabled) {
    props['aria-disabled'] = true;
  }
  var contentClassName = ecx(['ads-box__content', {
    'ads-box__content--loading': props.loading
  }]);
  var boxClassName = ecx(['ads-box', {
    'ads-box--sm': props.boxSize === 'sm',
    'ads-box--elevated': props.elevated
  }], props.className);
  var borderColor = getBorderColor(props);
  return /*#__PURE__*/React.createElement("div", Object.assign({
    ref: ref
  }, props, {
    "data-encore-id": ENCORE_ADS_BUSINESS_DATA_IDS.AdsBox,
    className: boxClassName,
    style: _objectSpread({
      borderColor: borderColor,
      '--ads-box-elevated-shadow': '0 4px 8px 0 #1818181a'
    }, props.style)
  }), props.disabledOverlay && /*#__PURE__*/React.createElement(DisabledOverlay, null), props.loading && /*#__PURE__*/React.createElement("div", {
    className: ecx(['ads-box__loading-wrapper'])
  }, /*#__PURE__*/React.createElement(LoadingIndicator, {
    size: "large",
    "aria-valuetext": "loading"
  })), /*#__PURE__*/React.createElement("div", {
    className: contentClassName
  }, children));
});